import '../pcss/app.pcss';
import 'virtual:svg-icons-register';
import { init as initCookieThough, show as showCookieThough, onPreferencesChanged, getPreferences } from 'cookie-though';
import 'lazysizes';
import { Livewire, Alpine } from '../../vendor/livewire/livewire/dist/livewire.esm';
import AlpineFloatingUI from '@awcodes/alpine-floating-ui'
import NotificationsAlpinePlugin from '../../vendor/filament/notifications/resources/js/components/notification.js'
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
import AirDatepicker from 'air-datepicker';
import 'air-datepicker/air-datepicker.css';
import 'livewire-sortable';
import * as focusTrap from 'focus-trap';
// core version + navigation, pagination modules:
import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import { set } from 'lodash';
Swiper.use([Navigation, Pagination, Autoplay]);
// init Swiper:
window.Swiper = Swiper;
Alpine.plugin(AlpineFloatingUI);
Alpine.plugin(NotificationsAlpinePlugin);
window.Alpine = Alpine;
window.AirDatepicker = AirDatepicker;
window.Livewire = Livewire;
Livewire.start();


initCookieThough(window.cookieconfig);

const applyConsent = (preferences) => {
    const hasStatistics = preferences.cookieOptions.some(
        option => option.id === 'statistics' && option.isEnabled === true
    );

    const consentMode = {
        'analytics_storage': hasStatistics ? 'granted' : 'denied',
        'ad_storage': hasStatistics ? 'granted' : 'denied',
        'ad_user_data': hasStatistics ? 'granted' : 'denied',
        'ad_personalization': hasStatistics ? 'granted' : 'denied',
    };

    // `gtag` bestaat alleen als de GTM-container is ingesteld: de laag die de
    // functie definieert staat in de layout achter
    // `@if(config('services.google.tagmanager.key'))`. Staat die sleutel niet in
    // .env, dan is `gtag` een niet-bestaande naam en gooit deze regel een
    // ReferenceError. Dat is geen kleine fout: dit bestand is één module, dus
    // alles hierna wordt niet meer uitgevoerd — de photoswipe-lightbox, de
    // modals, de swipers. Dan opent een klik op een galerijfoto de afbeelding
    // gewoon in de browser, want de lightbox heeft nooit iets aan die link
    // gehangen. Alleen bezoekers die hun cookievoorkeur al bewaard hebben
    // komen hier langs, dus in een verse browser leek er niets aan de hand.
    if (typeof gtag === 'function') {
        gtag('consent', 'update', consentMode);
    }

    localStorage.setItem('consentMode', JSON.stringify(consentMode));
};

// Restore previously-saved consent on every page load (returning visitors).
// isCustomised is only true once the user has actually made a choice, so
// brand-new visitors stay at the default (denied) instead of being auto-granted.
const savedPreferences = getPreferences();
if (savedPreferences.isCustomised) {
    applyConsent(savedPreferences);
}

// Update consent whenever the user changes preferences in the banner.
onPreferencesChanged((preferences) => {
    window.dataLayer?.push({ 'event': 'preferences_changed' });
    applyConsent(preferences);
});

// Om dezelfde reden een controle: de knop staat in de voettekst en in het
// legal-menu, maar een sjabloon zonder die twee (de afrekenlayout) heeft ze
// niet, en dan zou `undefined.addEventListener` de rest van dit bestand
// meesleuren.
const changeCookiePref = document.getElementsByClassName('js-change-prefs')[0];

if (changeCookiePref) {
    changeCookiePref.addEventListener('click', (e) => {
        e.preventDefault();
        showCookieThough();
    });
}

// Ook hier optioneel doorlopen: `.cookie-though` is een element dat het
// cookie-pakket zelf aanmaakt, en de shadow root komt er een tel later bij.
// Was dit ongedekt, dan sleurde het de service-worker-opruiming eronder mee.
const overwriteCSS = () => {
    const cookieThough = document.querySelector('.cookie-though');
    const [declineButton] = cookieThough?.shadowRoot?.querySelectorAll('.ct-button') ?? [];

    declineButton?.remove();
};


window.focusTrap = focusTrap;
window.parents = (el, selector) => {
    const parents = [];
    while ((el = el.parentNode) && el !== document) {
    if (!selector || el.matches(selector)) parents.unshift(el);
    }
    return parents;
}
const lightbox = new PhotoSwipeLightbox({
    gallery: '.js-gallery',
    children: 'a.js-pswp',
    pswpModule: () => import('photoswipe')
});
lightbox.init();
document.addEventListener('click', (event) => {
    let el;
    if (event.target.matches('[data-modal-trigger]')) {
        el = event.target;
    } else {
        el = parents(event.target, '[data-modal-trigger]')[0] || null;
    }
    if (el && el.getAttribute('data-modal-trigger')) {
        document.dispatchEvent(new CustomEvent('modal:open', {
            detail: {
                id: el.getAttribute('data-modal-trigger'),
            }
        }));
    }
});
/*
 * Header-verbergen-bij-scrollen: uit, net als op de v2-site.
 *
 * Daar staat dit blok óók in commentaar, dus `is-scrolled` komt er nooit op. Het
 * basisproject heeft het wél aanstaan, en met trayco's `_header.pcss` erbij doet
 * dat iets zichtbaars: `.c-header__searchcontainer.is-scrolled` gaat op
 * `opacity: 0` en schuift tachtig pixels omhoog onder `lg`, en verhuist naar
 * `order: 9999` daarboven. De zoekbalk in de kop verdween dus zodra je 120
 * pixels naar beneden scrolde — iets wat de echte site niet doet.
 *
 * Laten staan als commentaar in plaats van weggooien: het hoort bij de
 * `.is-scrolled`-regels die in _header.pcss wél bestaan, en zo is te zien dat
 * het een keuze was.
 *
let lastScrollTop = 0;
const searchElement = document.querySelector('.js-searchelement');
const headerElement = document.querySelector('.js-header');
var headerScrollCallback = function () {
    if (headerElement){
        var st = window.scrollY || document.documentElement.scrollTop;
        if (!document.documentElement.classList.contains('is-locked')) {
            if (st < lastScrollTop) {
                headerElement.classList.remove('is-scrolled');
                searchElement.classList.remove('is-scrolled');
            } else {
                if (st > 120) {
                    headerElement.classList.add('is-scrolled');
                    searchElement.classList.add('is-scrolled');
                    lastScrollTop = st;
                }
            }
        }
        lastScrollTop = st <= 0 ? 0 : st;
    }
};
window.addEventListener('scroll', throttle(headerScrollCallback, 700, { leading: true, trailing: true }));
*/
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.js-thumb').forEach((item) => {
        item.addEventListener('click', (event) => {
            event.preventDefault();
            let bigimageurl = item.dataset.bigimageurl;
            let bigimage = document.querySelectorAll('.js-bigimage')[0];
            let bigimageTrigger = document.querySelectorAll('.js-bigimage-trigger')[0];
            bigimage.setAttribute('src', bigimageurl);
            bigimageTrigger.setAttribute('data-index', item.dataset.index);
        });
    });
    var defaultPopup = document.getElementById("popupModal");
    if(defaultPopup){
        document.dispatchEvent(new CustomEvent('popup:open'));
    }
    document.querySelectorAll('.js-bigimage-trigger').forEach((item) => {
        item.addEventListener('click', (event) => {
            let index = item.dataset.index;
            let pswpitemtoclick = document.querySelector(`[data-pswp-index="${index}"]`);
            pswpitemtoclick.click();
        });
    });
    document.querySelectorAll('.js-showmoreimagesclick').forEach((item) => {
        item.addEventListener('click', (event) => {
            let index = item.dataset.index;
            let pswpitemtoclick = document.querySelector(`[data-pswp-index="${index}"]`);
            pswpitemtoclick.click();
        });
    });
}, false);
function syncHeight() {
    /*
    document.documentElement.style.setProperty(
        '--window-inner-height',
        `${window.innerHeight}px`
    );
    let osk = window.innerHeight - window.visualViewport.height;
    document.documentElement.style.setProperty(
        '--osk-height',
        `${osk}px`
    );
    let searchbox = document.querySelector('.c-autocomplete__container');
    if(searchbox){
        if(osk > 0){
            searchbox.style.paddingBottom = osk + "px";
        }
        //searchbox.style.maxHeight = window.visualViewport.height+"px";
        //searchbox.style.height = window.visualViewport.height + "px";
    }
    */
    let searchbox = document.querySelector('.c-header__searchcontainer');
    if(searchbox){
        let osk = window.innerHeight - window.visualViewport.height;
        searchbox.style.bottom = osk+"px";
    }
}
window.visualViewport.addEventListener('resize', syncHeight);
overwriteCSS();
window.addEventListener('load', () => {
    if (!('serviceWorker' in navigator)) {
        return;
    }

    const offlineModeEnabled =
        document.querySelector('meta[name="offline-mode"]')?.content === '1';

    if (offlineModeEnabled) {
        navigator.serviceWorker.register('/service-worker.js');
        return;
    }

    // Offline mode is off: never install the (buggy) service worker, and
    // remove any worker/cache a previous visit may have left behind.
    navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => registration.unregister());
    });

    if ('caches' in window) {
        caches.delete('offline');
    }
});
